import { useEffect } from "react"
import styled from "styled-components"
import { Application, useApplicationStore } from "@features/candidatureMgmt/applicationStore"
import { ApplicationCard } from "@features/applicationsManager/ApplicationCard"
import FilterAndSortList from "@components/filters/FilterAndSortList/FilterAndSortList"
import { usePropertyStore } from "@features/property/propertyStore"
import PortalShell from "../Common/PortalShell"

const AdminSurface = styled.section`
  padding: clamp(1rem, 3vw, 2rem);
  border: 1px solid #c4d0da;
  border-radius: 2px;
  background: #ffffff;
  box-shadow: 0 18px 50px rgba(8, 36, 60, 0.05);
`

export function ApplicationsManager() {
  const { applications, fetchAll: fetchApplications, updateApplication, removeApplication } = useApplicationStore()
  const { fetchAll: fetchProperties } = usePropertyStore()

  useEffect(() => {
    fetchApplications().catch(console.error)
    fetchProperties().catch(console.error)
  }, [fetchApplications, fetchProperties])

  function handleEdit(id: string, partialData: Partial<Application>) {
    updateApplication(id, partialData).catch(console.error)
  }

  function handleStatusChange(id: string, newStatus: string) {
    updateApplication(id, { status: newStatus }).catch(console.error)
  }

  function handleRemove(id: string) {
    removeApplication(id).catch(console.error)
  }

  const applicationNotDiscarded = applications.filter((application) => application.status !== "Discarté")

  return (
    <PortalShell title={`Candidatures · ${applicationNotDiscarded.length}`} eyebrow="Administration">
      <AdminSurface>
        <FilterAndSortList<Application>
          items={applications}
          renderItem={(item) => (
            <ApplicationCard key={item.id} data={item} onEdit={handleEdit} onRemove={handleRemove} onStatusChange={handleStatusChange} />
          )}
          searchFields={["id", "status", "apartmentAddress", "firstName", "lastName", "email", "phone", "desiredSize", "moveInDate", "submittedAt"]}
          sortOptions={[
            { value: "submittedAt", label: "Candidature soumise" },
            { value: "moveInDate", label: "Prise de possession" },
            { value: "status", label: "Statut" },
            { value: "apartmentAddress", label: "Adresse" },
            { value: "desiredSize", label: "Grandeur souhaitée" },
          ]}
          defaultSort="submittedAt"
          defaultSortOrder="desc"
        />
      </AdminSurface>
    </PortalShell>
  )
}

export default ApplicationsManager
